import React from 'react'
import Body from '../../components/Users/Chat/Body'

const userChat = () => {
  return (
    <Body/>
  )
}

export default userChat